export default "__VITE_ASSET__Bkt8fA85__"